(function showhideScript($, Drupal) {
  Drupal.behaviors.showhide = {
    attach(context) {
      const facts = $('.quick-fact__fact', context);
      let i = 0;
      facts.hide().eq(i).show();

      $('.quick-fact__another-fact', context).on('click', (e) => {
        e.preventDefault();

        i = (i + 1) % facts.length;
        facts.hide().eq(i).show();
      });
    },
  };
}(jQuery, Drupal));
